<template>
    <q-header class="bg-primary text-white bg-grey-9">
        <q-toolbar>
            <q-toolbar-title class="flex items-center">
                <img src="/img/Logo_Original_Blanc_100px.png" class="q-mr-lg q-pb-sm">
                BarTradingX.com
            </q-toolbar-title>
        </q-toolbar>
    </q-header>
</template>

<script>
export default {
  name: "Header",
}
</script>